import * as React from "react";

export const IconCompanyListImport = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_30934_28461)">
        <path
          d="M11.6667 2.16602L5.00001 2.16602C4.08334 2.16602 3.34168 2.91602 3.34168 3.83268L3.33334 17.166C3.33334 18.0827 4.07501 18.8327 4.99168 18.8327L15 18.8327C15.9167 18.8327 16.6667 18.0827 16.6667 17.166V7.16602L11.6667 2.16602ZM15 17.166H5.00001L5.00001 3.83268L10.8333 3.83268V7.99935L15 7.99935V17.166Z"
          fill="currentColor"
        />
        <path
          d="M13.3333 12.9923L12.1583 11.8173L10.8333 13.134V9.66732H9.16668V13.134L7.84168 11.809L6.66668 12.9923L9.99168 16.334L13.3333 12.9923Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_30934_28461">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
